export default __webpack_public_path__ + "static/media/Icons_Home Icon.11ed58a6.svg";